import { toJS } from 'mobx';
import { AnalyticsGroupBy } from '@sprinklr/stories/analytics/AnalyticsRequest';
import { WidgetDimensionKey } from 'utils/Widget/WidgetDimensionKey';

export function getWidgetDimensionKeyFromAnalyticsGroupBy(
    dimension: AnalyticsGroupBy
): WidgetDimensionKey {
    const dimensionRaw = toJS(dimension, { recurseEverything: true });

    // this removes the clientId if it is an empty object
    // helps custom dimensions resolve correctly
    if (
        dimensionRaw.details?.clientId &&
        Object.keys(dimensionRaw.details.clientId)?.length === 0
    ) {
        delete dimensionRaw.details.clientId;
    }

    return WidgetDimensionKey.create(dimensionRaw);
}
